const CREATE_PUSH_NOTIFICATION = "CREATE_PUSH_NOTIFICATION";
const CREATE_PUSH_NOTIFICATION_SUCCESS = "CREATE_PUSH_NOTIFICATION_SUCCESS";
const CREATE_PUSH_NOTIFICATION_FAILURE = "CREATE_PUSH_NOTIFICATION_FAILURE";
const CLEAR_CREATE_PUSH_NOTIFICATION = "CLEAR_CREATE_PUSH_NOTIFICATION";

const CreatePushNotificationsSymbols = {
  CREATE_PUSH_NOTIFICATION_SUCCESS,
  CREATE_PUSH_NOTIFICATION_FAILURE,
  CREATE_PUSH_NOTIFICATION,
  CLEAR_CREATE_PUSH_NOTIFICATION,
};
export default CreatePushNotificationsSymbols;
